import type { AccentPalette } from "../types";

export const ACCENT_EXECUTIVE_REPORTING: AccentPalette = {
    label: "Executive Reporting",
    inflow: { base: "#2F8068", selected: "#46A88C" },
    outflow: { base: "#B5714C", selected: "#C9977B" },
    icons: {
        "ri-account-circle-line": { pillHex: "#CAD7EC", chartHex: "#3C64AA" },
        "ri-arrow-left-right-line": { pillHex: "#ECCACD", chartHex: "#C14E56" },
        "ri-bank-card-line": { pillHex: "#CAECD2", chartHex: "#318C45" },
        "ri-bank-line": { pillHex: "#DCCAEC", chartHex: "#743CAA" },
        "ri-bill-line": { pillHex: "#ECE6CA", chartHex: "#C1AA4E" },
        "ri-book-2-line": { pillHex: "#CAE9EC", chartHex: "#31838C" },
        "ri-bookmark-line": { pillHex: "#ECCADF", chartHex: "#AA3C80" },
        "ri-box-3-line": { pillHex: "#D5ECCA", chartHex: "#73C14E" },
        "ri-briefcase-line": { pillHex: "#CACBEC", chartHex: "#31348C" },
        "ri-building-line": { pillHex: "#ECD3CA", chartHex: "#AA583C" },
        "ri-calculator-line": { pillHex: "#CAECDD", chartHex: "#4EC18D" },
        "ri-car-line": { pillHex: "#E7CAEC", chartHex: "#7D318C" },
        "ri-cash-line": { pillHex: "#E8ECCA", chartHex: "#9BAA3C" },
        "ri-coins-line": { pillHex: "#CADEEC", chartHex: "#4E90C1" },
        "ri-computer-line": { pillHex: "#ECCAD4", chartHex: "#8C314B" },
        "ri-exchange-dollar-line": { pillHex: "#CAECCA", chartHex: "#3CAA3D" },
        "ri-file-list-3-line": { pillHex: "#D4CAEC", chartHex: "#704EC1" },
        "ri-file-paper-2-line": { pillHex: "#ECDECA", chartHex: "#8C6731" },
        "ri-funds-line": { pillHex: "#CAECE8", chartHex: "#3CAA9D" },
        "ri-gift-line": { pillHex: "#ECCAE6", chartHex: "#C14EAD" },
        "ri-government-line": { pillHex: "#DCECCA", chartHex: "#618C31" },
        "ri-group-line": { pillHex: "#CAD2EC", chartHex: "#3C56AA" },
        "ri-hammer-line": { pillHex: "#ECCCCA", chartHex: "#C1534E" },
        "ri-hand-coin-line": { pillHex: "#CAECD6", chartHex: "#318C50" },
        "ri-home-8-line": { pillHex: "#E0CAEC", chartHex: "#813CAA" },
        "ri-landscape-line": { pillHex: "#ECEACA", chartHex: "#C1B84E" },
        "ri-lightbulb-line": { pillHex: "#CAE5EC", chartHex: "#31788C" },
        "ri-line-chart-line": { pillHex: "#ECCADB", chartHex: "#AA3C72" },
        "ri-macbook-line": { pillHex: "#D1ECCA", chartHex: "#65C14E" },
        "ri-megaphone-line": { pillHex: "#CDCAEC", chartHex: "#39318C" },
        "ri-money-dollar-circle-line": { pillHex: "#ECD7CA", chartHex: "#AA663C" },
        "ri-percent-line": { pillHex: "#CAECE1", chartHex: "#4EC19B" },
        "ri-pie-chart-2-line": { pillHex: "#EBCAEC", chartHex: "#89318C" },
        "ri-pie-chart-line": { pillHex: "#E4ECCA", chartHex: "#8DAA3C" },
        "ri-printer-line": { pillHex: "#CADAEC", chartHex: "#4E81C1" },
        "ri-question-line": { pillHex: "#ECCAD0", chartHex: "#8C313F" },
        "ri-receipt-line": { pillHex: "#CAECCF", chartHex: "#3CAA4A" },
        "ri-safe-line": { pillHex: "#D9CAEC", chartHex: "#7F4EC1" },
        "ri-scales-3-line": { pillHex: "#ECE3CA", chartHex: "#8C7231" },
        "ri-settings-4-line": { pillHex: "#CAECEC", chartHex: "#3CA9AA" },
        "ri-shake-hands-line": { pillHex: "#ECCAE2", chartHex: "#C14E9E" },
        "ri-shield-check-line": { pillHex: "#D8ECCA", chartHex: "#568C31" },
        "ri-shopping-bag-3-line": { pillHex: "#CACEEC", chartHex: "#3C49AA" },
        "ri-stock-line": { pillHex: "#ECD0CA", chartHex: "#C1624E" },
        "ri-store-2-line": { pillHex: "#CAECDA", chartHex: "#318C5B" },
        "ri-team-line": { pillHex: "#E4CAEC", chartHex: "#8F3CAA" },
        "ri-time-line": { pillHex: "#EBECCA", chartHex: "#BBC14E" },
        "ri-timer-line": { pillHex: "#CAE1EC", chartHex: "#316D8C" },
        "ri-tools-line": { pillHex: "#ECCAD7", chartHex: "#AA3C64" },
        "ri-truck-line": { pillHex: "#CDECCA", chartHex: "#56C14E" },
        "ri-umbrella-line": { pillHex: "#D2CAEC", chartHex: "#45318C" },
        "ri-user-settings-line": { pillHex: "#ECDCCA", chartHex: "#AA743C" },
        "ri-wallet-line": { pillHex: "#CAECE6", chartHex: "#4EC1AA" },
    },
};
